"use client"
import React from "react";
import SocialLinks from "@/components/social/SocialLinks";
import UralityAvatarImage from "@/components/shared/UralityAvatarImage";
import AssociatedCommunities from "@/components/shared/AssociatedCommunities";
import { useConfig } from "@/lib/providers/ConfigProvider";
import { useMediaQuery } from "react-responsive";
import { Container, Row, Col } from "react-bootstrap";

import "@/components/shared/ProfileInfoView.css";

const ProfileInfoView = ({
  thumbnail,
  inline,
  anchor,
  target,
  header,
  profile,
  prefix,
  cta,
  addDescription,
  addSocialLinks
}) => {
  const isSm = useMediaQuery({ query: "(max-width: 575.98px)" });
  const { webUrl } = useConfig();
  if (profile) {
    const profileUrl = webUrl + profile.resourceName;
    if (isSm && !inline) {
      return (
        <Container className="profile-info-view center-child-div-parent">
          <Row className="logo">
            <Col>
              <UralityAvatarImage
                imageId={profile.logoId}
                size={thumbnail ? thumbnail : "md"}
                addClass="center-child-div-child"
                name={profile.displayName}
                type={profile.userProfileType}
              />
            </Col>
          </Row>
          <Row className="title">
            <Col>
              {header && <h2>{header}</h2>}
              {anchor && <h3>{profile.displayName}</h3>}
              {!anchor && (
                <a href={profileUrl} target={target ?? "_self"}>
                  <h3>
                    {prefix}
                    {profile.displayName}
                  </h3>
                </a>
              )}
            </Col>
          </Row>
          {addDescription && (
            <Row className="description">
              <Col>
                <p>{profile.description}</p>
              </Col>
            </Row>
          )}
          {addSocialLinks && profile.socialProfile.length > 0 && (
            <Row className="social">
              <Col>
                <div>
                  <SocialLinks
                    ownerId={profile.id}
                    socialProfile={profile.socialProfile}
                    containerClassNameOverride="post-profile-social-container"
                  />
                </div>
              </Col>
            </Row>
          )}
          {cta && (
            <Row className="cta">
              <Col>{cta}</Col>
            </Row>
          )}
        </Container>
      );
    } else {
      return (
        <div>
          <div className="media profile-media-padding profile-info-view">
            <div
              className={
                "profile-photo-wrapper " + (thumbnail ? thumbnail : "md")
              }
            >
              <UralityAvatarImage
                imageId={profile.logoId}
                size={thumbnail ? thumbnail : "md"}
                name={profile.displayName}
                type={profile.userProfileType}
              />
            </div>
            <div className="media-body">
              <>
                {header && <h3 className="header">{header}</h3>}
                {anchor && (
                  <>
                    {isSm && (
                      <h3 className="title" style={{ marginBottom: 0 }}>
                        {profile.displayName}
                      </h3>
                    )}
                    {!isSm && (
                      <h1 className="title" style={{ marginBottom: 0 }}>
                        {profile.displayName}
                      </h1>
                    )}
                  </>
                )}
                {!anchor && (
                  <a href={profileUrl} target={target}>
                    <h4 style={{ marginBottom: 0 }}>
                      {prefix}
                      {profile.displayName}
                    </h4>
                  </a>
                )}
              </>
              {addDescription && (
                <>
                  {isSm && (
                    <span className="description">{profile.description}</span>
                  )}
                  {!isSm && (
                    <p className="description">{profile.description}</p>
                  )}
                </>
              )}
              {addSocialLinks && profile.socialProfile.length > 0 && (
                <div className="social">
                  <SocialLinks
                    ownerId={profile.id}
                    socialProfile={profile.socialProfile}
                    containerClassNameOverride="post-profile-social-container"
                  />
                </div>
              )}
            </div>
          </div>
          {cta && <div className="cta">{cta}</div>}
        </div>
      );
    }
  } else {
    return null;
  }
};
export default ProfileInfoView;
